
export default () => (dispatch, getState) => {

  const { token, wtRegion } = getState();

  const url = `${process.env.REACT_APP_API_URL}/modelportfolio/all/`;
  fetch(`${url}?wtRegion=${wtRegion}`, { 
    headers: {
      Authorization: token &&
        `Token ${token}`,
    }
  })
    .then(d => {
      if(d.status >= 400){
        return;
      }      
        return d.json().then(response => {

          const models = response.filter( model => model.holdings && Array.isArray(model.holdings) && model.holdings.length > 0);
          dispatch({ type: 'LOAD_MODEL_PORTFOLIOS', modelPortfolios: models })
        })
    })
    .catch(error => {
      console.error(error);
    });
};



// WEBPACK FOOTER //
// ./src/actions/query-api/model-portfolios.js